import React from "react";

const CardEstadisticas = ({ data }) => {
  return (
    <div className="w-full flex flex-col sm:flex-row justify-center gap-6 text-primario">
      {data.map((item, index) => (
        <div
          key={index}
          className={`flex flex-row sm:flex-col sm:justify-center items-center p-5 sm:p-6 md:p-8 w-full sm:w-[45%] lg:w-[22%] gap-3 rounded-lg rounded-tl-none bg-secundario shadow-[-10px_10px_0px_0px_#0d2334]`}
        >
          <i className={`${item.icon}  text-5xl sm:text-6xl 2xl:text-7xl`} />
          <div className="text-left sm:text-center">
            <p className="text-2xl sm:text-3xl 2xl:text-5xl font-semibold">
              {item.numero}
            </p>
            <p className="text-base xl:text-2xl hyphens-none">{item.texto}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardEstadisticas;